import mountOptionPicker from './optionPicker';
import {
    IOptionPickerColorItem,
} from '@vfde-brix-ws10/option-picker';

 /**
  * Mount Color Option Picker
  * @param container
  * @param id
  * @param items
  * @param onChangeAction
  */
export const mountColorOptionPicker = (container: HTMLElement, id: string, items: IOptionPickerColorItem[], onChangeAction?: (value: string) => void) => {

    return mountOptionPicker(container, id, 'color', items, onChangeAction, 'stacked');
};
